export const MOMENT_DATE_TIME = 'DD.MM.YYYY HH:mm:ss';
export const graphColors = {

    solar_line: "#EAB839FF",
    solar_fill: "#EAB83910",
    solar_var: "#EAB83903",
    solar_highlight: "#EAB83960",

    oa_line: "#92288CFF",
    oa_fill_unknown: "#926B8D10",
    oa_fill: "#92288C10",
    oa_var: "#92288C03",
    oa_highlight: "#92288C60",

    p1_line: "#3BB44BFF",
    p1_fill: "#3BB44B10",
    p1_var: "#3BB44B03",
    p1_highlight: "#3BB44B60",

    p2_line: "#0071BDFF",
    p2_fill: "#0071BD10",
    p2_var: "#0071BD03",
    p2_highlight: "#0071BD60",

    p3_line: "#F15A25FF",
    p3_fill: "#F15A2510",
    p3_var: "#F15A2503",
    p3_highlight: "#F15A2560",

    battery_line: "#8D542EFF",
    battery_fill: "#8D542E10",
    battery_var: "#8D542E03",
    battery_highlight: "#8D542E60",
};

export const colorsCI = {
    base: [
        '#FF0000',
        '#FFAA00',
        '#FFD500',
        '#FFFF00',
        '#2C02FF',
        '#003308',
        '#006611',
        '#00991A',
        '#00CC22'
    ],
    transparent: [
        '#FF000099',
        '#FFAA0099',
        '#FFD50099',
        '#FFFF0099',
        '#2C02FF99',
        '#00330899',
        '#00661199',
        '#00991A99',
        '#00CC2299'
    ]
}

export const colorList = [
    {
        border: '#e6194BFF',
        fill: '#e6194B10',
        hover: '#e6194B60'
    },{
        border: '#3cb44bFF',
        fill: '#3cb44b10',
        hover: '#3cb44b60'
    },{
        border: '#ffe119FF',
        fill: '#ffe11910',
        hover: '#ffe11960'
    },{
        border: '#4363d8FF',
        fill: '#4363d810',
        hover: '#4363d860'
    },{
        border: '#f58231FF',
        fill: '#f5823110',
        hover: '#f5823160'
    },{
        border: '#911eb4FF',
        fill: '#911eb410',
        hover: '#911eb460'
    },{
        border: '#42d4f4FF',
        fill: '#42d4f410',
        hover: '#42d4f460'
    },{
        border: '#f032e6FF',
        fill: '#f032e610',
        hover: '#f032e660'
    },{
        border: '#bfef45FF',
        fill: '#bfef4510',
        hover: '#bfef4560'
    },{
        border: '#fabed4FF',
        fill: '#fabed410',
        hover: '#fabed460'
    },{
        border: '#469990FF',
        fill: '#46999010',
        hover: '#46999060'
    },{
        border: '#dcbeffFF',
        fill: '#dcbeff10',
        hover: '#dcbeff60'
    },{
        border: '#9A6324FF',
        fill: '#9A632410',
        hover: '#9A632460'
    },{
        border: '#fffac8FF',
        fill: '#fffac810',
        hover: '#fffac860'
    },{
        border: '#800000FF',
        fill: '#80000010',
        hover: '#80000060'
    },{
        border: '#aaffc3FF',
        fill: '#aaffc310',
        hover: '#aaffc360'
    },{
        border: '#808000FF',
        fill: '#80800010',
        hover: '#80800060'
    },{
        border: '#ffd8b1FF',
        fill: '#ffd8b110',
        hover: '#ffd8b160'
    },{
        border: '#000075FF',
        fill: '#00007510',
        hover: '#00007560'
    },{
        border: '#000000FF',
        fill: '#00000010',
        hover: '#00000060'
    },{
        border: '#a9a9a9FF',
        fill: '#a9a9a910',
        hover: '#a9a9a960'
    }
];

export const fillBox = {
    position: 'absolute',
    width: '-webkit-fill-available',
    top: 0,
    backgroundColor: '#00000020',
    height: '-webkit-fill-available',
    margin: '2px',
    borderRadius: '1.5em',
    display: 'flex'
};

export const fillBoxContent = {
    backgroundColor: '#00000088',
    color: 'white',
    width: 'fit-content',
    padding: '0.5em',
    borderRadius: '0.6em',
    lineHeight: '1em',
    margin: 'auto',
    fontSize: '1.5em'
};

export const errorBoxContent = {
    backgroundColor: '#FF0000AA',
    color: 'white',
    width: 'fit-content',
    padding: '0.5em',
    borderRadius: '0.6em',
    lineHeight: '1em',
    margin: 'auto',
    fontSize: '1.5em'
};

export const smartTrainingPeriod = {
    periodLength: 336,      // Hours (14 days)
    displayPeriod: 168      // Hours (7 days)
};

export const calcKwh = (list) => {
    if(!list) return 0;
    let sum = 0;
    for(const dev of list){
        sum += dev.x * dev.duration / 3600000000;
    }
    return Math.round(sum * 100) / 100;
};

export const calcConsumption = (deviceList, deviceId) => {
    if(!deviceList) return 0;
    const list = deviceList.filter(item => item.id === deviceId);
    return calcKwh(list);
};

export const CLOUD_PLANS = {
    BASIC: {
        LIMITATIONS: {
            SWITCH_COUNT: 0
        }
    },
    STANDARD: {
        LIMITATIONS: {
            SWITCH_COUNT: 5
        }
    },
    PREMIUM: {
        LIMITATIONS: {
            SWITCH_COUNT: -1 // unlimited
        }
    }
};

